import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

type SenderTypeRowProps = {
  selected: boolean;
  label: string;
  onSelect: () => void;
};

export function SenderTypeRow({
  selected,
  label,
  onSelect,
}: SenderTypeRowProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      onClick={onSelect}
      className={cn(
        "flex w-full items-center gap-3 rounded-lg border border-transparent px-3 py-2.5 text-left text-sm transition-colors",
        "hover:bg-muted/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-custom-outline/40",
        selected && "border-border bg-muted/40",
      )}
    >
      <span
        className={cn(
          "flex size-5 shrink-0 items-center justify-center rounded-full border-2",
          selected
            ? "border-emerald-600 bg-emerald-600 text-white"
            : "border-muted-foreground/30 bg-background",
        )}
        aria-hidden
      >
        {selected ? <Check className="size-3.5 stroke-[3]" /> : null}
      </span>
      <span className="font-medium text-foreground">{label}</span>
    </button>
  );
}
